__turbopack_context__.v({
  "blink": "LoadingDots-module-scss-module___YCj3a__blink",
  "root": "LoadingDots-module-scss-module___YCj3a__root",
});
